<template>
  <div class="modal fade" id="refund-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeRefundModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-money mr-5"></i>{{'partial_refund' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div>
            <div class="row">
              <div class="col-xs-12">
                <p>Bitte benutzen Sie die Teilgutschrifts-Anfrage ausschließlich für Retouren, die Sie getragen zurückerhalten haben.
                  <br>Rabattanfragen aufgrund eines Artikelmangels gegenüber dem Endkunden sind generell <strong>nicht</strong> möglich.
                </p>
                <hr>
              </div>
              <div class="col-xs-12">
                <label>Bitte wählen Sie ein Bild des Artikels aus:</label>
                <div class="clear pb-5"></div>
                <file-upload @file="checkFiles($event)" @error="$emit('alert', $event)"></file-upload>
              </div>
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-xs-12">
              <label>Ihre Nachricht:</label> <textarea type="text" class="form-control" v-model="data.message"></textarea>
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-xs-12">
              <label>{{'article_condition' | translate}}</label> <input type="text" class="form-control" v-model="data.condition">
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-xs-12">
              <label>{{'requested_reduction'| translate}}</label>
              <input v-validate="{required: true, regex:/^([0-9]+|[0-9]+,[0-9]{0,2}?)$/ }" decimals="2" :data-vv-as="'requested_reduction'| translate" class="form-control" name="requested_reduction" type="text" v-model="data.requested_reduction">
              <span v-show="errors.has('requested_reduction')" class="small text-danger">{{ errors.first('requested_reduction') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <b-btn type="button" :disabled="data.images.length === 0 || data.message === '' || errors.any()" @click="$emit('action', data)" class="btn btn-success btn-app pull-right" data-dismiss="modal"><span class="fa fa-paper-plane"></span>{{'submit' | translate}}</b-btn>
          <b-btn type="button" class="btn btn-danger btn-app btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate}}</b-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['action', 'id'],
  data () {
    return {
      data: {
        reason: 'item_broken',
        images: [],
        type: 'partial_refund',
        message: '',
        condition: '',
        requested_reduction: ''
      }
    }
  },
  methods: {
    checkFiles (event) {
      this.data.images = event
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>
